import { UploadedFile } from '@shared/models/uploaded-file'
import { ServiceReminder } from '@shared/models/service-reminder.model'
import { BaseModel } from '@shared/models/base.model'
import { toUploadedFile } from '@app/core/helpers/to-uploaded-file'

export interface ServiceRecordInput {
  date: string
  odometer: number
  engineHours: number
  note: string
  cost: string
  files: File[]
}

export class ServiceRecordRow extends BaseModel {
  id: number
  cost: number
  date: string
  odometer: number
  engineHours: number
  note: string
  files: UploadedFile[]
  createdAt: string
  createdBy: { id: number; fullName: string }
  updatedAt: string
  updatedBy: { id: number; fullName: string }
  status: ServiceRecordStatus

  constructor(src?: ServiceRecordRow) {
    super(src)

    this.files = this.files?.map(toUploadedFile)
  }
}

export interface ServiceRecord extends ServiceRecordRow {
  reminder: ServiceReminder
}

export enum ServiceRecordStatus {
  Draft = 'draft',
  Active = 'active',
}
